import { Box } from 'enova-frontend-components';
import React from 'react';

import { SortAttribute } from '../../../../../../hooks/useBuildingFilter/context';
import useBuildingFilter from '../../../../../../hooks/useBuildingFilter';

import { FilterChip } from './filterChip';
import { SortChip } from './sortChip';

export const Filters = () => {
  const { filterValues, buildingList } = useBuildingFilter();

  // Calculate total number of active filters
  const filterCount = Object.values(filterValues).reduce((acc, cur) => acc + (cur?.length || 0), 0);

  // Filter should be displayed if there are more than 10 buildings or if any filters are active
  const displayFilters = (buildingList?.buildings && buildingList.buildings.length > 10) || filterCount !== 0;

  if (!displayFilters) {
    return null;
  }

  return (
    <Box display="flex" gap={4}>
      {/* Filter Chip and Filter Drawer.  */}
      <FilterChip filterCount={filterCount} />
      {/* Address sorting Chip */}
      <SortChip sortAttribute={SortAttribute.ADDRESS} />
      {/* Date registered sorting Chip */}
      <SortChip sortAttribute={SortAttribute.REGISTERED} />
    </Box>
  );
};
